import React, { useRef, useEffect } from "react";
import "./Category.css";
import { ImagesApp } from "../../Images/ImagesApp";

const categories = [
  { img: ImagesApp.car, name: "Cars" },
  { img: ImagesApp.Steel, name: "Steel" },
  { img: ImagesApp.Aluminium, name: "Aluminium" },
  { img: ImagesApp.Brass2, name: "Brass" },
  { img: ImagesApp.Bike, name: "Bikes" },
  { img: ImagesApp.cable, name: "Cable" },
  { img: ImagesApp.computer, name: "Computer" },
  { img: ImagesApp.cycle, name: "Cycle" },
  { img: ImagesApp.iron, name: "Iron" },
  { img: ImagesApp.lead1, name: "Lead" },
  { img: ImagesApp.newpaper, name: "Newspaper" },
  { img: ImagesApp.plastic, name: "Plastic" },
  { img: ImagesApp.pump, name: "Pump" },
  { img: ImagesApp.railway, name: "Railway" },
  { img: ImagesApp.ship, name: "Ship" },
];

function Category() {
  const scrollRef = useRef(null);

  // Auto scroll only on mobile
  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    const autoScroll = () => {
      if (window.innerWidth <= 768) {
        const maxScroll = container.scrollWidth - container.clientWidth;
        if (container.scrollLeft >= maxScroll - 5) {
          container.scrollTo({ left: 0, behavior: "smooth" });
        } else {
          container.scrollBy({ left: 170, behavior: "smooth" });
        }
      }
    };

    const interval = setInterval(autoScroll, 2500);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="category-section">
      <div className="category-wrapper">
        <div className="category-container" ref={scrollRef}>
          {categories.map((cat, i) => (
            <div key={i} className="category-item">
              <div className="category-card">
                <div className="image-box">
                  <img src={cat.img} alt={cat.name} />
                </div>
              </div>
              <p className="category-name">{cat.name}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Category;
